export interface BatchTrcAuthorityRegisterRequest {
  startNumFrom: string
  startNumTo: string
  isReplaceAuthority: boolean
  convertHyoukiToFull: boolean
  convertKanaToHalf: boolean
  inputFileMarc: string
  memo: string
  batchType: string
}

export function BatchTrcAuthorityRegisterRequestToJSON(
  value: BatchTrcAuthorityRegisterRequest
): any {
  return {
    start_num_from: value.startNumFrom,
    start_num_to: value.startNumTo,
    is_replace_authority: value.isReplaceAuthority,
    convert_hyouki_to_full: value.convertHyoukiToFull,
    convert_kana_to_half: value.convertKanaToHalf,
    input_file_marc: value.inputFileMarc,
    memo: value.memo,
    batch_type: value.batchType
  }
}
